// extracted by mini-css-extract-plugin
export default {"main":"writestring_main__fXU4X","texttyping":"writestring_texttyping__xo95h","type":"writestring_type__y6y8T"};